import React from 'react';
import { observer } from 'mobx-react-lite';
import { EventQueueWireDto } from '@mark43/cad-api';
import { PriorityBox } from './priority-box';
import { useFrPriorityAppearance } from '../../../configurable-colors-sounds/priority-colors';

export const FrConfiguredPriorityBox = observer(function FrConfiguredPriorityBox({
    eventQueueView,
    children,
}: {
    eventQueueView: EventQueueWireDto | undefined;
    children: React.ReactNode;
}): React.ReactElement {
    const appearance = useFrPriorityAppearance(eventQueueView);
    return (
        <PriorityBox
            isFlashing={appearance.isFlashing}
            flashColor={appearance.flashColor}
            backgroundColor={appearance.fill}
            color={appearance.text}
            isBold={appearance.isBold}
        >
            {children}
        </PriorityBox>
    );
});
